export default {"src":"/_next/static/media/scholarship_page_background_light.73b897f6.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};